import create from 'zustand';

import { artistTypes } from '@/types';

interface ArtistState {
  authenticate: {
    isAuthenticated: boolean;
    isPhoneVerified: boolean;
  };
  defaultArtist: artistTypes.Artist;
  artist: artistTypes.Artist;
  setArtist: (artist: artistTypes.Artist) => void;
  setAuthentication: (data: { isAuthenticated: boolean; isPhoneVerified: boolean }) => void;
  //clear data
  setArtistToDefault: () => void;
}

const useArtistStore = create<ArtistState>((set) => ({
  defaultArtist: {} as artistTypes.Artist,
  artist: {} as artistTypes.Artist,
  authenticate: {
    isAuthenticated: false,
    isPhoneVerified: false,
  },
  setArtist: (artist: artistTypes.Artist) => set({ artist }),
  setAuthentication: (data: { isAuthenticated: boolean; isPhoneVerified: boolean }) =>
    set({
      authenticate: {
        isAuthenticated: data.isAuthenticated,
        isPhoneVerified: data.isPhoneVerified,
      },
    }),
  setArtistToDefault: () =>
    set({
      artist: {} as artistTypes.Artist,
      authenticate: {
        isAuthenticated: false,
        isPhoneVerified: false,
      },
    }),
}));

export default useArtistStore;
